import { useEffect, useRef, useState } from "react";
import {
  documentHeight,
  documentWidth,
} from "../../../utils/measuresForResponsiveness";

interface LazyImageProps {
  src: string;
  index: number;
  handleMove: (event: any, index: number) => void;
  onMouseEnter: (event: any, index: number) => void;
  destroyElement: () => void;
}

export const LazyImage = ({
  src,
  index,
  handleMove,
  onMouseEnter,
  destroyElement,
}: LazyImageProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const imgRef = useRef<SVGGElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.disconnect();
          }
        });
      },
      { rootMargin: "1000px" }
    );

    if (imgRef.current) observer.observe(imgRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // Fallback to load images if they are not intersecting initially
    if (!isVisible) {
      const timeout = setTimeout(() => setIsVisible(true), 3000);
      return () => clearTimeout(timeout);
    }
  }, [isVisible]);
  const height = documentHeight + 4;
  return (
    <g
      key={`${index}-group`}
      ref={imgRef}
      transform={`matrix(1, 0, 0, 1, 0, ${index * height})`}
      onMouseMove={(event: any) => handleMove(event, index)}
      onMouseLeave={() => destroyElement()}
      onMouseEnter={(event: any) => onMouseEnter(event, index)}
    >
      {isVisible && (
        <image
          display="block"
          xlinkHref={src}
          key={index}
          width={documentWidth}
          height={documentHeight}
        />
      )}
    </g>
  );
};
